import React, { useState } from "react";
import { postData } from "../services/FetchNodeservices";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import toast from "react-hot-toast";
import Adminlogin from "../../../Animation/Adminlogin.json";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Input handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await postData("adminlogin/login", formData);

      if (res.status) {
        toast.success(res.message || "Admin Logged In");

        // ⭐ Save Admin Data
        localStorage.setItem("ADMIN", JSON.stringify(res.data));

        // ⭐ Save JWT token for Authorization
        if (res.token) {
          localStorage.setItem("TOKEN", res.token); // <-- BECAUSE API EXPECTS THIS
        }

        navigate("/adminhome", { replace: true });
      } else {
        toast.error(res.message || "Invalid Email or Password");
      }
    } catch (err) {
      console.error("Admin login error:", err);
      toast.error("Server error, try again later");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-tr from-slate-50 via-slate-100/40 to-indigo-50/25 dark:from-[#0b0f19] dark:via-[#0e1322] dark:to-[#171e30] flex items-center justify-center px-4 transition-colors duration-200">
      <div className="glass-panel rounded-3xl p-[2px] max-w-4xl w-full shadow-2xl overflow-hidden animate-fadeIn">
        <div className="flex flex-col md:flex-row overflow-hidden rounded-3xl">
          {/* Form Section */}
          <div className="flex-1 px-6 py-10 md:px-10 flex flex-col justify-center">
            <h2 className="text-3xl font-extrabold mb-6 text-center md:text-left text-slate-800 dark:text-slate-100 tracking-tight">
              Admin Login
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Email */}
              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider pl-1">Email Address</label>
                <input
                  type="email"
                  required
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="glass-input w-full px-4 py-2.5 rounded-xl outline-none text-sm"
                  placeholder="admin@morganplacement.com"
                />
              </div>

              {/* Password */}
              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider pl-1">Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    required
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="glass-input w-full px-4 py-2.5 pr-12 rounded-xl outline-none text-sm"
                    placeholder="••••••••"
                  />

                  <button
                    type="button"
                    className="absolute right-3 top-3 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg hover:shadow-indigo-650/10 text-white py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 mt-2"
              >
                {loading ? "Logging in..." : "Sign In"}
              </button>
            </form>
          </div>

          {/* Animation */}
          <div className="flex-1 bg-indigo-50/30 dark:bg-slate-900/20 flex items-center justify-center p-6 border-t md:border-t-0 md:border-l border-slate-200/40 dark:border-slate-800/40">
            <Lottie animationData={Adminlogin} loop className="max-w-[320px] w-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
